/** Matriz de permisos staff — Structura Market (paridad Booking Hub). */

export const STAFF_PERMISSION_ROWS = [
  { key: "pedidos", label: "Ver y gestionar pedidos" },
  { key: "pesaje", label: "Módulo de pesaje" },
  { key: "productos", label: "Productos y categorías" },
  { key: "produccion", label: "B2B / Mayorista" },
  { key: "metricas", label: "Métricas" },
  { key: "configuracion", label: "Configuración del negocio" },
] as const;

export type StaffPermKey = (typeof STAFF_PERMISSION_ROWS)[number]["key"];

/**
 * Admin/platform UI defaults ONLY — NOT nav authorization law.
 * Staff workspace nav uses operational access (`filterStaffNavByOperationalAccess`).
 * Backend `assertSmStaffPermission` is the mutation authorization SoT.
 */
export const STAFF_PERMISSION_DEFAULTS: Record<StaffPermKey, boolean> = {
  pedidos: true,
  pesaje: true,
  productos: true,
  produccion: false,
  metricas: false,
  configuracion: false,
};
